<template lang="pug">
.container-outras-habilidades
  .header
    .label Todas Habilidades
    .adicionar-habilidades
      ButtonPadrao(iconLeft variant="negative" @click="adicionarHabilidade")
        LucideIcon(slot="icon-left" name="Plus" :size="16")
        | Adicionar
  .legenda-niveis
    .legenda-header
      LucideIcon(name="Info" :size="14")
      span.titulo Nível desejado
    .niveis-grid
      .nivel-item(v-for="nivel in niveisInfo" :key="nivel.valor")
        .nivel-estrelas
          LucideIcon(
            v-for="n in 5" 
            :key="n"
            name="Star" 
            :size="12" 
            :color="n <= nivel.estrelas ? '#facc15' : '#27272a'"
            :fill="n <= nivel.estrelas ? '#facc15' : 'none'"
          )
        .nivel-info
          .nivel-nome {{ nivel.estrelas }} {{ nivel.nome }}
          .nivel-desc {{ nivel.descricao }}
  .corpo
    .habilidades(v-for="(item, i) in getTodasHabilidades" :key="item.value + '-' + i" :class="[ item.isNew && 'nova-habilidade' ]")
      .grupo-badge(v-if="item.grupo_nome" :class="getBadgeClass(item.grupo_nome)") {{ item.grupo_nome }}
      .form
        el-form(class="form-custom-nexa" :model="item" :ref="`formRef${i}`" label-width="100px")
          .apagar
            LucideIcon(name="Trash2" :size="16" color="#fff" @click="removerHabilidade(i)")
            .selecao-habilidade
              SelectGroup(
                :options="getClasses" 
                v-model="item.value" 
                label="Nome da Habilidade"
                :filterable="true"
                :disabledOptions="getHabilidadesSelecionadas"
                @input="atualizarHabilidade(item.value, 'label', $event)"
              )
              //el-input(v-model="item.habilidade" placeholder="Sua habilidade")
        .selecao-nivel
          SelectPadrao(
            :options="getNiveis" 
            v-model="item.nivel" 
            label="Nível"
            @input="atualizarHabilidade(item.value, 'nivel', $event)"
          )
      .visualizacao
        BarraHabilidades(
          :key="item.nivel"
          skill="Visualização"
          :level="item.nivel"
          :showLevel="false"
        )
  .btn-salvar
    ButtonPadrao(iconLeft @click="salvarAlteracoes" v-loading="salvando")
      LucideIcon(slot="icon-left" name="Save" :size="16")
      | Salvar Alterações
</template>

<script>
import ButtonPadrao from '@/components/ui/ButtonPadrao.vue'
import SelectPadrao from '@/components/ui/SelectPadrao.vue'
import SelectGroup from '@/components/ui/SelectGroup.vue'
import BarraHabilidades from '@/components/ui/BarraHabilidades.vue'
import MessageMixin from '@/mixins/MessageMixin'

export default {
  mixins: [MessageMixin],
  
  components: {
    ButtonPadrao,
    SelectPadrao,
    SelectGroup,
    BarraHabilidades
  },

  computed: {
    getNiveis() {
      return this.$store.getters['habilidades/niveis'] || []
    },
    getClasses() {
      return this.$store.getters['classes/getAllClasses'] || []
    },
    getTodasHabilidades() {
      return this.$store.getters['habilidades/todasHabilidades'] || []
    },
    getHabilidadesSelecionadas() {
      // Retorna array de IDs das habilidades já selecionadas (excluindo vazias e temp)
      return this.getTodasHabilidades
        .filter(h => h.value && !h.value.toString().startsWith('temp-'))
        .map(h => h.value)
    }
  },

  data() {
    return {
      salvando: false,
      habilidades: [{
        habilidade: '',
        nivel: ''
      }],
      niveisInfo: [
        {
          valor: 0,
          estrelas: 0,
          nome: 'Iniciando: ',
          descricao: 'Caso você não tenha conhecimento suficiente para avaliar seu nível, selecione esta opção'
        },
        {
          valor: 1,
          estrelas: 1,
          nome: 'Aprendiz: ',
          descricao: 'Conhecimento básico, está começando a aprender sobre o tema'
        },
        {
          valor: 2,
          estrelas: 2,
          nome: 'Praticante: ',
          descricao: 'Tem alguma experiência prática, mas ainda está desenvolvendo suas habilidades no tema'
        },
        {
          valor: 3,
          estrelas: 3,
          nome: 'Profissional: ',
          descricao: 'Tem domínio do tema, consegue aplicar seus conhecimentos de forma eficaz e consistente'
        },
        {
          valor: 4,
          estrelas: 4,
          nome: 'Professor: ',
          descricao: 'Tem um conhecimento aprofundado, é capaz de ensinar e orientar outros sobre o tema'
        },
        {
          valor: 5,
          estrelas: 5,
          nome: 'Mestre: ',
          descricao: 'É uma referência no tema, com conhecimento excepcional e experiência significativa, reconhecido como um especialista na área'
        }
      ]
    }
  },

  created() {
    try {
      // Se não houver nenhuma habilidade, adiciona uma vazia
      if (this.getTodasHabilidades.length === 0) {
        this.$store.commit('habilidades/ADICIONAR_HABILIDADE', {
          label: '',
          value: `temp-${Date.now()}`,
          nivel: 'Iniciando',
          grupo_nome: ''
        })
      }
    } catch (error) {
      console.error('Erro:', error)
    }
  },

  watch: {
    getTodasHabilidades: {
      handler(newVal) {
        this.$store.dispatch('perfil/atualizarOutrasHabilidades', newVal)
      },
      deep: true
    }
  },

  methods: {
    getBadgeClass(grupoNome) {
      const grupo = grupoNome?.toLowerCase() || ''
      
      if (grupo.includes('frontend')) return 'badge-frontend'
      if (grupo.includes('backend')) return 'badge-backend'
      if (grupo.includes('mobile')) return 'badge-mobile'
      if (grupo.includes('devops')) return 'badge-devops'
      if (grupo.includes('database') || grupo.includes('banco')) return 'badge-database'
      if (grupo.includes('design') || grupo.includes('ui') || grupo.includes('ux')) return 'badge-design'
      
      return 'badge-default'
    },
    adicionarHabilidade() {
      // Verifica se já existe alguma habilidade vazia ou temporária
      const temHabilidadeVazia = this.getTodasHabilidades.some(h => 
        !h.value || 
        h.value === '' || 
        (typeof h.value === 'string' && h.value.startsWith('temp-'))
      )
      
      if (temHabilidadeVazia) {
        this.showWarningMessage('Preencha a habilidade anterior antes de adicionar uma nova')
        return
      }
      
      const newSkill = {
        label: '',
        value: `temp-${Date.now()}`,
        nivel: 'Iniciando',
        grupo_nome: '',
        isNew: true
      }
      this.$store.commit('habilidades/ADICIONAR_HABILIDADE', newSkill)
      
      // Remove a flag após a animação
      setTimeout(() => {
        this.$store.commit('habilidades/REMOVER_FLAG_NEW', newSkill.value)
      }, 2000)
    },
    async removerHabilidade(index) {
      const habilidade = this.getTodasHabilidades[index]
      const skillId = habilidade.value
      
      // Se for uma habilidade temporária (ainda não salva), apenas remove localmente
      if (typeof skillId === 'string' && skillId.startsWith('temp-')) {
        if (this.getTodasHabilidades.length > 1) {
          this.$store.commit('habilidades/REMOVER_HABILIDADE', skillId)
        } else {
          // Se for a última, reseta os valores mas mantém o item
          this.$store.commit('habilidades/REMOVER_HABILIDADE', skillId)
          this.$store.commit('habilidades/ADICIONAR_HABILIDADE', {
            label: '',
            value: `temp-${Date.now()}`,
            nivel: 'Iniciando',
            grupo_nome: ''
          })
        }
        return
      }
      
      // Verifica se é uma habilidade já salva no backend (tem relationId)
      if (!habilidade.relationId) {
        // Não tem relationId, então é uma habilidade nova ainda não salva
        if (this.getTodasHabilidades.length > 1) {
          this.$store.commit('habilidades/REMOVER_HABILIDADE', skillId)
        } else {
          this.$store.commit('habilidades/REMOVER_HABILIDADE', skillId)
          this.$store.commit('habilidades/ADICIONAR_HABILIDADE', {
            label: '',
            value: `temp-${Date.now()}`,
            nivel: 'Iniciando',
            grupo_nome: ''
          })
        }
        return
      }
      
      // Se for uma habilidade já salva, chama a API para deletar usando relationId
      try {
        const result = await this.$store.dispatch('usuarioSkills/deleteUsuarioSkill', habilidade.relationId)
        
        if (result.success) {
          this.showSuccessMessage('Habilidade removida com sucesso!')
          
          // Remove do estado local
          if (this.getTodasHabilidades.length > 1) {
            this.$store.commit('habilidades/REMOVER_HABILIDADE', skillId)
          } else {
            // Se for a última, reseta os valores mas mantém o item
            this.$store.commit('habilidades/REMOVER_HABILIDADE', skillId)
            this.$store.commit('habilidades/ADICIONAR_HABILIDADE', {
              label: '',
              value: `temp-${Date.now()}`,
              nivel: 'Iniciando',
              grupo_nome: ''
            })
          }
          
          // Atualiza os dados do usuário
          const user = JSON.parse(localStorage.getItem('user-nexa')) || {}
          const userId = user.id
          if (userId) {
            await this.$store.dispatch('usuario/fetchUsuarioById', userId)
          }
        } else {
          this.showErrorMessage(result.error || 'Erro ao remover habilidade')
        }
      } catch (error) {
        console.error('Erro ao remover habilidade:', error)
        this.showErrorMessage('Erro ao remover habilidade')
      }
    },
    atualizarHabilidade(habilidadeValue, campo, novoValor) {
      const payload = { value: habilidadeValue }
      
      if (campo === 'nivel') {
        payload.novoNivel = novoValor
      } else if (campo === 'label') {
        // Busca qual grupo contém essa skill e o nome da skill
        let grupoNome = ''
        let skillNome = ''
        
        this.getClasses.forEach(classe => {
          const skill = classe.skills?.find(s => s.id === novoValor)
          if (skill) {
            grupoNome = classe.name
            skillNome = skill.name
          }
        })
        
        // Atualiza a label localmente antes de enviar para o Vuex
        const habilidade = this.getTodasHabilidades.find(h => h.value === habilidadeValue)
        if (habilidade && skillNome) {
          habilidade.label = skillNome
        }
        
        payload.novaLabel = novoValor
        payload.grupoNome = grupoNome
        payload.value = habilidadeValue
      }
      
      this.$store.dispatch('habilidades/atualizarHabilidade', payload)
    },
    async salvarAlteracoes() {
      const user = JSON.parse(localStorage.getItem('user-nexa')) || {}
      const userId = user.id || 0
      const userName = user.name || ''
      
      // Filtra habilidades válidas (não temporárias e não vazias)
      const habilidadesValidas = this.getTodasHabilidades.filter(hab => 
        hab.value && !hab.value.toString().startsWith('temp-')
      )
      
      if (habilidadesValidas.length === 0) {
        this.showWarningMessage('Adicione pelo menos uma habilidade antes de salvar')
        return
      }
      
      // Agrupa habilidades por classe
      const classesMap = new Map()
      
      habilidadesValidas.forEach(hab => {
        // Busca a classe e skill correspondentes
        this.getClasses.forEach(classe => {
          const skill = classe.skills?.find(s => s.id === hab.value)
          if (skill) {
            if (!classesMap.has(classe.id)) {
              classesMap.set(classe.id, {
                id: classe.id,
                name: classe.name,
                skills: []
              })
            }
            
            classesMap.get(classe.id).skills.push({
              id: skill.id,
              name: skill.name,
              nivel: hab.nivel
            })
          }
        })
      })
      
      const payload = {
        usuario_id: userId,
        usuario: userName,
        classe: Array.from(classesMap.values())
      }
      
      this.salvando = true
      
      try {
        const result = await this.$store.dispatch('usuarioSkills/addUsuarioSkill', payload)
        
        if (result.success) {
          this.showSuccessMessage('Habilidades salvas com sucesso!')
          
          // Atualiza as informações do usuário
          await this.$store.dispatch('usuario/fetchUsuarioById', userId)
        } else {
          this.showErrorMessage(result.error || 'Erro ao salvar habilidades')
        }
        
      } catch (error) {
        console.error('Erro ao salvar habilidades:', error)
        this.showErrorMessage('Erro ao salvar habilidades')
      } finally {
        this.salvando = false
      }
    }
  }
}
</script>

<style lang="scss">
.container-outras-habilidades{
  width: 100%;
  border: 1px solid $borderColor;
  box-sizing: border-box;
  border-radius: 8px;
  background: $corFundoPadraoDashboard;

  .header{
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 24px;
    box-sizing: border-box;
    margin-bottom: 0;

    .label{
      font-size: 20px;
      font-weight: 700;
      color: $corVerdeClaro;
    }

    .adicionar-habilidades{
      .botao{
        height: 36px;
      }
    }
  }

  .legenda-niveis {
    margin: 0 24px 24px;
    padding: 16px 20px;
    background: rgba(183, 255, 0, 0.03);
    border: 1px solid rgba(183, 255, 0, 0.1);
    border-radius: 8px;

    .legenda-header {
      display: flex;
      align-items: center;
      gap: 8px;
      margin-bottom: 12px;

      svg {
        color: $corVerdeClaro;
        flex-shrink: 0;
      }

      .titulo {
        font-size: 13px;
        font-weight: 600;
        color: $corVerdeClaro;
      }
    }

    .niveis-grid {
      display: flex;
      flex-direction: column;
      gap: 8px;

      .nivel-item {
        display: flex;
        align-items: center;
        gap: 12px;
        padding: 0;

        .nivel-estrelas {
          display: flex;
          gap: 2px;
          flex-shrink: 0;
          min-width: 65px;
        }

        .nivel-info {
          display: flex;
          align-items: baseline;
          gap: 8px;
          flex: 1;

          .nivel-nome {
            font-size: 13px;
            font-weight: 500;
            color: $corBranco;
            min-width: 110px;
            flex-shrink: 0;
          }

          .nivel-desc {
            font-size: 12px;
            color: $corCinzaClaro;
            line-height: 1.4;
          }
        }
      }
    }

    @media screen and (max-width: 768px) {
      padding: 12px 16px;

      .niveis-grid {
        .nivel-item {
          flex-direction: column;
          align-items: flex-start;
          gap: 6px;
          padding-bottom: 8px;
          border-bottom: 1px solid rgba(255, 255, 255, 0.05);

          &:last-child {
            border-bottom: none;
            padding-bottom: 0;
          }

          .nivel-info {
            flex-direction: column;
            align-items: flex-start;
            gap: 4px;
            width: 100%;

            .nivel-nome {
              min-width: auto;
            }
          }
        }
      }
    }
  }

  .corpo {
    padding: 0 24px 24px;

    .habilidades{
      border: 1px solid $borderColor;
      border-radius: 8px;
      background: $corPreto;
      padding: 16px;
      position: relative;

      .grupo-badge {
        position: absolute;
        top: -10px;
        left: 12px;
        padding: 3px 10px;
        border-radius: 10px;
        font-size: 10px;
        font-weight: 500;
        text-transform: uppercase;
        letter-spacing: 0.5px;
        z-index: 2;
        
        &.badge-frontend {
          background: rgba(96, 165, 250, 0.15);
          color: #60a5fa;
          border: 1px solid rgba(96, 165, 250, 0.3);
        }
        
        &.badge-backend {
          background: rgba(34, 197, 94, 0.15);
          color: #22c55e;
          border: 1px solid rgba(34, 197, 94, 0.3);
        }
        
        &.badge-mobile {
          background: rgba(168, 85, 247, 0.15);
          color: #a855f7;
          border: 1px solid rgba(168, 85, 247, 0.3);
        }
        
        &.badge-devops {
          background: rgba(251, 146, 60, 0.15);
          color: #fb923c;
          border: 1px solid rgba(251, 146, 60, 0.3);
        }
        
        &.badge-database {
          background: rgba(236, 72, 153, 0.15);
          color: #ec4899;
          border: 1px solid rgba(236, 72, 153, 0.3);
        }
        
        &.badge-design {
          background: rgba(250, 204, 21, 0.15);
          color: #facc15;
          border: 1px solid rgba(250, 204, 21, 0.3);
        }
        
        &.badge-default {
          background: rgba(183, 255, 0, 0.15);
          color: $corVerdeClaro;
          border: 1px solid rgba(183, 255, 0, 0.3);
        }
      }

      &.nova-habilidade {
        animation: pulseGreenGlow 2s ease-out;
      }

      &:not(:last-child){
        margin-bottom: 24px;
      }

      .header{
        display: flex;
        align-items: center;
        justify-content: space-between;

        .posicao{
          font-size: 16px;
          font-weight: 700;
          color: $corVerdeClaro;

          span{
            color: #fff;
            font-weight: 500;
            padding-left: 5px;
          }
        }
        .selecao-cor{
          width: 120px;
        }
      }
      .form{
        width: 100%;

        .apagar{
          position: relative;

          svg{
            position: absolute;
            right: 4px;
            cursor: pointer;

            &:hover{
              stroke: #f87171;
            }
          }
        }

        .selecao-nivel,
        .selecao-habilidade{
          .select-container{
            .el-select{
              width: 100%;

              .el-input{
                .el-input__inner{
                  background: #000;
                }
              }
            }
          }
        }
      }

      .visualizacao{
        margin-top: 24px;

        .progress-bar-container{
          .progress-bar-header{
            .title{
              color: $corValueInfoContato;
            }
          }
        }
      }
    }
  }

  .btn-salvar{
    padding: 16px 24px 24px;
    box-sizing: border-box;
    border-top: 1px solid $borderColor;
    display: flex;
    justify-content: flex-end;
  }

  @media (max-width: 500px) {
    .btn-salvar{
      justify-content: center;
    }
  }
}

@keyframes pulseGreenGlow {
  0% {
    box-shadow: 0 0 0 0 rgba(183, 255, 0, 0);
    border-color: $borderColor;
  }
  10% {
    box-shadow: 0 0 20px 5px rgba(183, 255, 0, 0.6);
    border-color: #b7ff00;
  }
  50% {
    box-shadow: 0 0 15px 3px rgba(183, 255, 0, 0.4);
    border-color: #b7ff00;
  }
  100% {
    box-shadow: 0 0 0 0 rgba(183, 255, 0, 0);
    border-color: $borderColor;
  }
}
</style>